class GirlverseQuiz extends HTMLElement {
  connectedCallback() {
    this.startButton = this.querySelector('[data-gv-start]');
    this.panel = this.querySelector('[data-gv-panel]');
    this.questions = [...this.querySelectorAll('[data-gv-question]')];
    this.result = this.querySelector('[data-gv-result]');
    this.scores = { books: 0, nature: 0, fashion: 0, science: 0, sports: 0 };
    this.startButton?.addEventListener('click', () => this.start());
    this.querySelectorAll('[data-gv-answer]').forEach((button) => button.addEventListener('click', () => this.answer(button.dataset.gvAnswer)));
    this.querySelector('[data-gv-restart]')?.addEventListener('click', () => this.restart());
  }
  start() { this.current = 0; this.classList.add('quiz-active'); this.panel.classList.add('is-open'); this.questions[0]?.classList.add('is-active'); this.panel.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  answer(value) { if (value && this.scores[value] !== undefined) this.scores[value]++; this.questions[this.current]?.classList.remove('is-active'); this.current++; if (this.current < this.questions.length) this.questions[this.current].classList.add('is-active'); else this.showResult(); }
  showResult() {
    const key = Object.entries(this.scores).sort((a,b) => b[1] - a[1])[0][0];
    const data = JSON.parse(this.querySelector(`[data-result-${key}]`).textContent);
    this.result.querySelector('img').src = data.image;
    this.result.querySelector('h3').textContent = data.title;
    this.result.querySelector('p').textContent = data.message;
    this.result.hidden = false;
  }
  restart() { this.scores = { books:0,nature:0,fashion:0,science:0,sports:0 }; this.result.hidden = true; this.current = 0; this.questions.forEach((q,i)=>q.classList.toggle('is-active',i===0)); }
}
if (!customElements.get('girlverse-quiz')) customElements.define('girlverse-quiz', GirlverseQuiz);
